import { message } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// @ts-ignore: Allow importing CSS without type declarations
import "./App.css";
import AppLayout from "./views/layout/layout";
import Login from "./views/pages/auth/Login";
import { Suspense, useEffect } from "react";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import SiteLoader from "./views/components/SiteLoader";
import { useUserStore } from "./store/slices/user";
import { useCompanyStore } from "./store/slices/company";
import { useGetMyCompany } from "./hooks/api/company/hooks";
import { TerminologyProvider } from "./lib/terminology";

import QuotePublicPage from "./views/pages/quotes/QuotePublicPage";
import InvoicePublicPage from "./views/pages/invoices/InvoicePublicPage";
import POPublicPage from "./views/pages/purchaseOrders/POPublicPage";
import SetupWizard from "./views/pages/setup/SetupWizard";

function App() {
  const [messageApi, contextHolder] = message.useMessage();

const { isLoggedIn, validateToken, isHydrated, user } = useUserStore();



   useEffect(() => {
    validateToken();
  }, []);

  const hydrateCompany = useCompanyStore((s) => s.setCompany);

  const { data, isSuccess } = useGetMyCompany({
    enabled: isLoggedIn,
  });

  useEffect(() => {
    if (isSuccess && data?.data) {
      hydrateCompany(data.data);
    }
  }, [isSuccess, data]);

  if (!isHydrated) {
    return <SiteLoader />;
  }




  return (
    <NuqsAdapter>
      <BrowserRouter basename="/">
        {contextHolder}
        <Routes>
          <Route path="/quote/:token" element={<QuotePublicPage />} />
          <Route path="/invoice/:token" element={<InvoicePublicPage />} />
          <Route path="/po/:token" element={<POPublicPage />} />
          <Route
            path="*"
            element={
              isLoggedIn ? (
                user && !user.onboarding_completed ? (
                  <SetupWizard />
                ) : (
                  <TerminologyProvider>
                    <Suspense fallback={<SiteLoader />}>
                      <AppLayout />
                    </Suspense>
                  </TerminologyProvider>
                )
              ) : (
                <Login />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </NuqsAdapter>
  );
}

export default App;